import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { RedFlagsAdapter } from '../../adapters/red-flags.adapter';
import {
  loadCompanyRedFlags,
  loadCompanyRedFlagsFailure,
  loadCompanyRedFlagsSuccess,
} from './company-red-flags.actions';

@Injectable()
export class CompanyRedFlagsEffects {
  private readonly actions$ = inject(Actions);
  private readonly redFlagsAdapter = inject(RedFlagsAdapter);

  loadCompanyRedFlags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCompanyRedFlags),
      exhaustMap(() =>
        this.redFlagsAdapter.getUsableRedFlags().pipe(
          map((redFlags) => loadCompanyRedFlagsSuccess({ redFlags })),
          catchError((error: unknown) => of(loadCompanyRedFlagsFailure({ error })))
        )
      )
    )
  );
}
